import axios from "axios";
import { URL_ADDRESS_LATLNG } from "../../../helpers/endpoint";
import { baseBackend } from "../../base/baseUrl";

export const getAddressAndLatLng = async (url) => {
  return await baseBackend.post(URL_ADDRESS_LATLNG, JSON.stringify({ url }), {
    headers: { "Content-Type": "application/json" },
  });
};
